import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from '../../components/layout/AppHeader.jsx';

/**
 * BOS+ Phase 6 — Absence & Accruals shell. Sidebar nav + <Outlet/>, reusing the
 * `hr-shell` layout/CSS (mirrors LearningShell). Additive absence layer.
 */

const NAV = [
  { to: '/absence/balances', label: 'Balances', testid: 'absence-nav-balances' },
  { to: '/absence/requests', label: 'Requests', testid: 'absence-nav-requests' },
  { to: '/absence/plans', label: 'Plans', testid: 'absence-nav-plans' },
  { to: '/absence/policies', label: 'Policies', testid: 'absence-nav-policies' },
];

export default function AbsenceShell() {
  return (
    <div className="hr-shell" data-testid="absence-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">Absence</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} data-testid={n.testid} className={({ isActive }) => (isActive ? 'active' : '')}>
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
